import React, { useEffect } from 'react'
import styled from 'styled-components'
import gsap from 'gsap'

const IndicatorView = styled.div`
  position: absolute;
  height: 40px;
  bottom: 60px;
  left: 50%;
  transform: translateX(-20px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  svg {
    transform: rotate(90deg);
    overflow: visible;
  }
`

const Text = styled.p`
  margin-top: 1.25rem;
  font-size: .875rem;
`

const Arrow = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='21.186' height='20.686'>
    <g fill='none' stroke='#fff' strokeMiterlimit='10'>
      <path data-name='Path 986' d='M10.49.354l9.989 9.989-9.99 9.99'/>
      <path className='vertical-line' data-name='Line 12' d='M20.062 10.343H.5'/>
    </g>
  </svg>
)

const Indicator = () => {
  // NOTE: X used due to rotation of element
  useEffect(() => {
    gsap.to('.vertical-line', {
      x: 10,
      duration: 1.2,
      repeat: -1,
      yoyo: true,
    })
  }, [])

  return (
    <IndicatorView>
      <Arrow />
      <Text>Scroll down</Text>
    </IndicatorView>
  )
}

export default Indicator